<div class="card-wrapper">
    <div class="value-wrapper" [style.width]="width" [style.background-color]="color" [style.box-shadow]="boxShadow">{{value}}</div>
    <div class="tail-wrapper">
        <div class="line" [style.background-color]="color" [style.border-color]="color"></div>
        <div class="dot" [style.background-color]="color" [style.border-color]="color" [style.box-shadow]="boxShadow"></div>
    </div>
    <div class="text-content" [style.color]="color">{{text}}</div>
</div>